import React from 'react';
import { Box, Button, Dialog, Typography } from '@mui/material';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import PaymentsIcon from '@mui/icons-material/Payments';
import { formatCents } from '../money';
import { COLORS } from '../theme';

export type TenderKind = 'card' | 'cash';

type Props = {
  open: boolean;
  total: number;
  onCancel: () => void;
  onPick: (kind: TenderKind) => void;
};

/** Two choices, both enormous. Card goes straight to the receipt
 *  prompt; cash detours through the change calculator. */
const TenderDialog: React.FC<Props> = ({ open, total, onCancel, onPick }) => (
  <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth>
    <Box sx={{ p: 3 }}>
      <Box sx={{ textAlign: 'center', mb: 3 }}>
        <Typography sx={{ color: COLORS.textMuted, letterSpacing: '0.1em' }}>
          TOTAL DUE
        </Typography>
        <Typography sx={{ fontWeight: 800, fontSize: '3rem', lineHeight: 1.1 }}>
          {formatCents(total)}
        </Typography>
      </Box>

      <Box sx={{ display: 'flex', gap: 2 }}>
        <TenderButton
          icon={<CreditCardIcon sx={{ fontSize: 52 }} />}
          label="CARD"
          onClick={() => onPick('card')}
        />
        <TenderButton
          icon={<PaymentsIcon sx={{ fontSize: 52 }} />}
          label="CASH"
          onClick={() => onPick('cash')}
        />
      </Box>

      <Box sx={{ textAlign: 'center', mt: 2 }}>
        <Button onClick={onCancel} sx={{ color: COLORS.textMuted }}>
          Cancel
        </Button>
      </Box>
    </Box>
  </Dialog>
);

const TenderButton: React.FC<{
  icon: React.ReactNode;
  label: string;
  onClick: () => void;
}> = ({ icon, label, onClick }) => (
  <Button
    onClick={onClick}
    variant="outlined"
    sx={{
      flex: 1,
      height: 160,
      flexDirection: 'column',
      gap: 1,
      fontSize: '1.3rem',
      fontWeight: 700,
      borderWidth: 2,
      borderColor: COLORS.border,
      color: COLORS.text,
      '&:hover': {
        borderWidth: 2,
        borderColor: COLORS.accent,
        backgroundColor: 'rgba(30,127,79,0.06)',
      },
    }}
  >
    {icon}
    {label}
  </Button>
);

export default TenderDialog;
